import PropTypes from 'prop-types';
import React from 'react';
import compose from '../../hoc/compose';
import { isRgbString, parseRgbString, applyOpacity, isHexString, hexToRgb, getLuminance } from '../../util/color';
var GRADIENT_MATCHER = 'linear-gradient|radial-gradient|conic-gradient';
function getShadeByLuminance(value, opacity) {
  return getNormalizedLuminance(value, opacity / 100) > 0.5 ? 'light' : 'dark';
}
function getClassNameByProps(_ref) {
  var getClassName = _ref.getClassName,
    disabled = _ref.disabled,
    selected = _ref.selected,
    value = _ref.value,
    opacity = _ref.opacity;
  var classNames = [value.match(GRADIENT_MATCHER) && 'gradient', getClassName('color-picker-input-ctrl'), disabled && 'disabled', selected && 'selected', getShadeByLuminance(value, opacity)];
  return classNames.filter(function (v) {
    return v;
  }).join(' ');
}
function tryGetRgbFromStringValue(value, opacity) {
  if (isRgbString(value)) {
    var _rgb$alpha;
    var rgb = parseRgbString(value);
    return applyOpacity(rgb, (_rgb$alpha = rgb.alpha) !== null && _rgb$alpha !== void 0 ? _rgb$alpha : 1);
  }
  if (isHexString(value)) {
    var _rgb = hexToRgb(value);
    return applyOpacity(_rgb, opacity);
  }
  return null;
}
function getNormalizedLuminance(value, opacity) {
  var rgb = typeof value === 'string' ? tryGetRgbFromStringValue(value, opacity) : null;
  return rgb ? getLuminance(rgb) : 1;
}
function getOpacity(props) {
  return /^rgba/.test(props.value) ? 1 : props.opacity / 100;
}
var ColorPickerInput = function ColorPickerInput(props) {
  return /*#__PURE__*/React.createElement('div', {
    className: 'color-picker-input-ctrl-wrapper'
  }, /*#__PURE__*/React.createElement('div', {
    onClick: props.disabled ? undefined : props.onClick,
    className: getClassNameByProps(props),
    style: {
      '--color': props.value,
      '--opacity': getOpacity(props)
    },
    'data-aid': props.automationId,
    'data-hook': props.dataHook
  }, props.symbol ? /*#__PURE__*/React.createElement('div', {
    className: 'color-picker-input-symbol-wrapper'
  }, /*#__PURE__*/React.createElement(props.symbol)) : undefined));
};
ColorPickerInput.displayName = 'ColorPickerInput';
ColorPickerInput.propTypes = {
  /** Set the value of the ColorPickerInput. Values can be either:
   * - A single color in HEX, RGB or RGBA
   * - One or more valid css gradient values (see examples here: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Images/Using_CSS_gradients)
   * @linkTypeTo https://developer.mozilla.org/en-US/docs/Web/CSS/color_value
   * @setTypeName color
   */
  value: PropTypes.string,
  /** opacity */
  opacity: PropTypes.number,
  /** onClick */
  onClick: PropTypes.func,
  /** symbol */
  symbol: PropTypes.element,
  /** selected */
  selected: PropTypes.bool
};
ColorPickerInput.defaultProps = {
  value: '#ffffff',
  opacity: 100,
  selected: false
};
export default compose(ColorPickerInput);